import { t } from "i18next";
import { useEffect, useState } from "react";
import { getVideos, getVideoTags } from "../../../../services/video";
import { Video, VideoTag } from "../../../../interfaces/video";
import { Badge, Button, Col, Form, Row } from "react-bootstrap";
import { VideoTagFilter } from "../../../general/video-tag-filter";

export function AthleteVideoList() {
    const [videos, setVideos] = useState<Video[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [tags, setTags] = useState<VideoTag[]>([]);
    const [searchText, setSearchText] = useState('');
    const [filterTagIds, setFilterTagIds] = useState<number[]>([]);

    useEffect(() => {
        getVideoTags()
            .then(response => setTags(response.data))
            .catch(error => console.log(error));

        getVideos('', 1, 12)
            .then(response => {
                const videosData = response.data;
                setVideos(videosData);
                setHasMore(videosData.length === 12);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const loadVideos = (search: string, tagIds: number[], page: number, append: boolean = false) => {
        getVideos(search, page, 12, tagIds.length > 0 ? tagIds : undefined)
            .then(response => {
                const videosData = response.data;
                if (append) {
                    setVideos(prev => [...prev, ...videosData]);
                } else {
                    setVideos(videosData);
                }
                setCurrentPage(page);
                setHasMore(videosData.length === 12);
            })
            .catch(error => {
                console.log(error);
            });
    };

    const handleSearchSubmit = (event: any) => {
        event.preventDefault();
        const s = event.target.search.value;
        setSearchText(s);
        loadVideos(s, filterTagIds, 1);
    }

    const handleTagFilterChange = (tagIds: number[]) => {
        setFilterTagIds(tagIds);
    }

    const handleTagClick = (tagId: number) => {
        const newTagIds = [tagId];
        setFilterTagIds(newTagIds);
        loadVideos(searchText, newTagIds, 1);
    }

    const handleLoadMore = (event: any) => {
        event.preventDefault();
        loadVideos(searchText, filterTagIds, currentPage + 1, true);
    }

    return (
        <div className="video-list-container">
            <h1>
                { t('videos')}
            </h1>
            <div className="filters-container">
                <Form onSubmit={ handleSearchSubmit }>
                    <Form.Group className="field-search" controlId="search">
                        <Form.Control type="search" placeholder={ t("Write to search") } />
                    </Form.Group>
                    { tags.length > 0 &&
                        <div className="field-tag">
                            <VideoTagFilter
                                tags={tags}
                                selectedTagIds={filterTagIds}
                                onChange={handleTagFilterChange}
                            />
                        </div>
                    }
                    <div className="actions">
                        <Button variant="primary" type="submit">
                            { t("search") }
                        </Button>
                    </div>
                </Form>
            </div>
            <div className="grid-container">
                <Row>
                    { videos.map((v: Video) => {
                        return <Col key={ 'video-' + v.id } xs={12} md={6} lg={4} xl={3}>
                            <div className="video-card">
                                <div className="heading">
                                    <div className="media">
                                        { v.media.length > 0 &&
                                            <video controls>
                                                <source src={ v.media[0].url } />
                                            </video>
                                        }
                                    </div>
                                    <div className="meta">
                                        <div className="name">
                                            { v.name }
                                        </div>
                                        { v.tags && v.tags.length > 0 &&
                                            <div className="tags">
                                                { v.tags.map((tag: VideoTag) => (
                                                    <Badge key={tag.id} bg="secondary" className="me-1" role="button" onClick={() => handleTagClick(tag.id)}>{tag.name}</Badge>
                                                ))}
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </Col>
                    })}
                </Row>
                { hasMore &&
                    <div className="load-more-container" style={{ textAlign: 'center', marginTop: '20px' }}>
                        <Button variant="primary" onClick={ handleLoadMore }>
                            { t("Load more") }
                        </Button>
                    </div>
                }
            </div>
        </div>

    )
}
